import { get, post, patch } from './_httpClient';

export async function getAttendancesAllUsers({ batchId }) {
  const { status, message, data } = await get(`/clp/attendances/users?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getAttendancesAllUsersByMentor({ batchId }) {
  const { status, message, data } = await get(`/clp/attendances/mentors?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getAttendancesDetailUsers({ userId }) {
  const { status, message, data } = await get(`/clp/attendances/users/${userId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function submitAttendances(payload) {
  const { status, message, data } = await post('/clp/attendances', payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function verifyAttendances({ attendanceId, payload }) {
  const { status, message, data } = await patch(`/clp/attendances/${attendanceId}/verify`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getTodayAttendance() {
  const { status, message, data } = await get('/clp/attendances/today');
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function getAttendanceByDate({ date }) {
  const { status, message, data } = await get(`/clp/attendances/by-date?date=${date}`);
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function getAttendanceQuota() {
  const { status, message, data } = await get('/clp/attendances/quota');
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function clockIn({ sessionDate, useQuota, lat, lng }) {
  const { status, message, data } = await post('/clp/attendances/clock-in', {
    sessionDate,
    useQuota,
    lat,
    lng,
  });
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function requestTolerance({ requestType, reason, sessionDate }) {
  const { status, message, data } = await post('/clp/attendances/tolerance-request', {
    requestType,
    reason,
    sessionDate,
  });
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function clockOut({ lat, lng, sessionDate }) {
  const { status, message, data } = await post('/clp/attendances/clock-out', { lat, lng, sessionDate });
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function submitLogbook({
  progress,
  nextSteps,
  challenges,
  supportNeeded,
  dailyReflection,
  mood,
  sessionDate,
}) {
  console.log(progress, nextSteps, challenges, supportNeeded, mood, sessionDate);
  const { status, message, data } = await post('/clp/attendances/logbook', {
    progress,
    nextSteps,
    challenges,
    supportNeeded,
    dailyReflection,
    mood,
    sessionDate,
  });
  if (status !== 'success') throw new Error(message);
  return data;
}

// Riwayat kehadiran + logbook milik siswa sendiri, difilter per
// hari/minggu/bulan relatif terhadap sebuah tanggal acuan. Dipakai peserta
// untuk keperluan pelaporan magang ke kampusnya.
export async function getAttendanceHistory({ range = 'day', date } = {}) {
  const params = new URLSearchParams({ range });
  if (date) params.set('date', date);
  const { status, message, data } = await get(`/clp/attendances/history?${params.toString()}`);
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function getAttendances({ page, limit, date, batchId }) {
  const { status, message, data } = await get(
    `/clp/admin/attendances?page=${page}&limit=${limit}&date=${date}&batchId=${batchId}`
  );
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function getAttendanceDetail(id) {
  const { status, message, data } = await get(`/clp/admin/attendances/${id}`);
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function reviewTolerance(id, { status }) {
  const { status: resStatus, message, data } = await patch(
    `/clp/admin/attendances/tolerance-requests/${id}`,
    { status }
  );
  if (resStatus !== 'success') throw new Error(message);
  return data;
}

// Kuota toleransi keterlambatan peserta (dilihat admin dari halaman detail
// absensi) beserta listing hari-hari yang sudah memakai kuota tersebut.
export async function getAdminAttendanceQuota(userId) {
  const { status, message, data } = await get(`/clp/admin/attendances/users/${userId}/quota`);
  if (status !== 'success') throw new Error(message);
  return data;
}

// Riwayat kehadiran harian seorang peserta, difilter per hari/minggu/bulan
// relatif terhadap sebuah tanggal acuan.
export async function getAdminAttendanceHistory(userId, { range = 'day', date } = {}) {
  const params = new URLSearchParams({ range });
  if (date) params.set('date', date);
  const { status, message, data } = await get(
    `/clp/admin/attendances/users/${userId}/history?${params.toString()}`,
  );
  if (status !== 'success') throw new Error(message);
  return data;
}

// --- Mentor (versi mentor dari endpoint admin di atas, dibatasi ke divisi
// yang dibimbing mentor tersebut) ---

export async function getMentorAttendances({ page, limit, date, batchId }) {
  const { status, message, data } = await get(
    `/clp/mentor/attendances?page=${page}&limit=${limit}&date=${date}&batchId=${batchId}`,
  );
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function getMentorAttendanceDetail(id) {
  const { status, message, data } = await get(`/clp/mentor/attendances/${id}`);
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function reviewMentorTolerance(id, { status }) {
  const { status: resStatus, message, data } = await patch(
    `/clp/mentor/attendances/tolerance-requests/${id}`,
    { status },
  );
  if (resStatus !== 'success') throw new Error(message);
  return data;
}

export async function getMentorAttendanceQuota(userId) {
  const { status, message, data } = await get(`/clp/mentor/attendances/users/${userId}/quota`);
  if (status !== 'success') throw new Error(message);
  return data;
}

export async function getMentorAttendanceHistory(userId, { range = 'day', date } = {}) {
  const params = new URLSearchParams({ range });
  if (date) params.set('date', date);
  const { status, message, data } = await get(
    `/clp/mentor/attendances/users/${userId}/history?${params.toString()}`,
  );
  if (status !== 'success') throw new Error(message);
  return data;
}

// Pengganti alur "verifikasi" lama — mentor menyinkronkan ulang skor
// kehadiran (dari sesi clock-in/out) ke evaluasi final BCF (tipe ATT).
export async function syncMentorAttendanceScore(userId) {
  const { status, message, data } = await post(`/clp/mentor/attendances/users/${userId}/sync-score`, {});
  if (status !== 'success') throw new Error(message);
  return data;
}
